export const LINKS = {
    WHATSAPP_FINANCE_SUPPORT: 'https://wa.me/5541995882766?text=Olá,%20gostaria%20de%20verificar%20pendências%20em%20meu%20cadastro.',
};
